// get Sync propify lead sources

export const GET_LEAD_SOURCES_REQUEST = 'GET_LEAD_SOURCES_REQUEST';
export const GET_LEAD_SOURCES_SUCCESS = 'GET_LEAD_SOURCES_SUCCESS';
export const GET_LEAD_SOURCES_FAILURE = 'GET_LEAD_SOURCES_FAILURE';